import { Link } from 'react-router-dom';
import './CoberturaNota.css';

const CoberturaNota = () => (
  <p className="cobertura-nota">
    Este servicio se presta en remoto a empresas de toda España. La oficina y la atención presencial están en Tenerife.{' '}
    <Link to="/donde-trabajamos">Dónde trabajamos</Link>
    {' · '}
    <Link to="/consultoria-tecnologica-tenerife">Consultoría en Tenerife</Link>.
  </p>
);

export default CoberturaNota;
